import { createContext } from "react";

export const ticketContext = createContext({});
